import React from 'react';
import { useQuery } from '@apollo/client';
import { vercel_base_url } from '../../../../util/config';
import { NUMBER_OF_ORDERS } from './ForYou.gql';
import { SITE_CONFIG } from '../../../App.gql';
import WalletCard from '../../../Wallet/WalletCard/WalletCard';

import * as Styled from './ForYou.styled';

/**
 * Displays Offers and Personalized Content to Logged In Users in Account Nav
 */
const ForYou = () => {
  const { data } = useQuery(NUMBER_OF_ORDERS, {
    context: { service: 'storefront' }
  });

  const { data: settingsData } = useQuery(SITE_CONFIG, {
    variables: { key: 'account' }
  });

  const config = settingsData?.settings[0].values;
  const numberOfOrders = data?.customer?.numberOfOrders;

  return (
    <Styled.ForYou>
      <WalletCard />
      <Styled.SectionHeader>What&apos;s New</Styled.SectionHeader>
      {numberOfOrders > 0 ? (
        <Styled.BuyAgainCard
          richTextContent={config?.buy_again_copy.value}
          buttonCopy={config?.buy_again_button_copy.value}
          size="small"
        />
      ) : (
        <Styled.InformationCard
          header={
            <>
              <Styled.CardTitle>Shop Best Sellers</Styled.CardTitle>
              <Styled.CardSubtitle>
                See what&apos;s popular.
              </Styled.CardSubtitle>
            </>
          }
          withDivider={false}
        >
          <Styled.ButtonLink
            href={`${vercel_base_url}/collections/best-sellers`}
            as="a"
          >
            <Styled.ButtonIcon isFull>Shop Best Sellers</Styled.ButtonIcon>
          </Styled.ButtonLink>
        </Styled.InformationCard>
      )}
      <Styled.DonationCounterWithData />
    </Styled.ForYou>
  );
};

export default ForYou;
